export const filters = {
  filter_character: [],
  all_characters: [],
  filters: {
    genders: "all",
    species: "all",
    films: "all",
  },
};
